import { render, staticRenderFns } from "./beneficiary-province-postcode.vue?vue&type=template&id=fd876cc6&"
import script from "./beneficiary-province-postcode.vue?vue&type=script&lang=js&"
export * from "./beneficiary-province-postcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports